import { makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface IEmployeeGroup {
  id: string
  main: boolean
  name: string
  legal_entity_id: string
  metadata: IEmployeeGroupSpainMetadata | Record<string, never>
}

export interface IEmployeeGroupSpainMetadata {
  id: string
  es_cccs_id: string
  employee_group_id: string
  payroll_agreements_id: string
}

class EmployeeGroup extends Model<IEmployeeGroup> {
  static urlRoot() {
    return '/employee_groups'
  }

  constructor(attr: IEmployeeGroup) {
    super(attr)
    makeObservable(this, {})
  }
}

export default EmployeeGroup
